import React, { useEffect, useRef, useState } from "react";
import "../../../Static/priceinfo.css";
import DropdownWithBtn from '../../FieldsComponents/DropdownWithBtn';
import QuotDiscountTable from './QuotDiscountTable'
import {
  Grid,
  Paper,
  Button,
  TextField,
  useMediaQuery,
  FormControl,
  Select,
  MenuItem
} from "@mui/material";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer
} from "@mui/material";

import { useParams } from "react-router-dom";
import ReactToPrint from "react-to-print";
import axios from "axios";

const QuotDiscount = () => {
  const { Id } = useParams();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const componentRef = useRef();
  const isDesktop = useMediaQuery("(min-width:768px)");
  const [rates, setRates] = useState([]);
  const [addedRows, setAddedRows] = useState([]);
  const [showAddedTable, setShowAddedTable] = useState(false);
  const [showRatesTable, setShowRatesTable] = useState(false);

  const [addedData, setAddedData] = useState(null);


  const [formData, setFormData] = useState({
    quotId: "",
    firmNm: "",
    partyNm: "",
    qtMemo: ""
  });

  const [quotList, setQuotList] = useState([]);
  const [scrDiscount, setScrDiscount] = useState("");
  const [milDiscount, setMilDiscount] = useState("");

  // ===== Fetch Header =====
  useEffect(() => {
    const fetchHeader = async () => {
      try {
        const res = await axios.get(
          `${baseUrl}?apicall=getMultipleQuotationData&mqtId=${Id}`
        );

        const data = res.data?.data || {};

        setFormData(prev => ({
          ...prev,
          firmNm: data.firmNm || "",
          partyNm: data.partyNm || "",
          qtMemo: data.qtMemo || ""
        }));
      } catch (err) {
        console.error(err);
      }
    };

    fetchHeader();
  }, [Id, baseUrl]);

  // ===== Fetch Dropdown =====
  useEffect(() => {
    const fetchList = async () => {
      try {
        const res = await axios.get(
          `${baseUrl}?apicall=getMultipleQuotationList&mqtId=${Id}`
        );

        const list = res.data?.data || [];

        const cleanList = list.map(item => ({
          ...item,
          ID: String(item.ID)
        }));

        setQuotList(cleanList);

        if (cleanList.length > 0) {
          setFormData(prev => ({
            ...prev,
            quotId: cleanList[0].ID
          }));
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchList();
  }, [Id, baseUrl]);
  useEffect(() => {
    const fetchRates = async () => {
      if (!formData.quotId) return;

      try {
        const selected = quotList.find(
          q => q.ID === formData.quotId
        );
        console.log("qmId=>", Id);
        console.log("qtno=>", selected.quotNo);
        if (!selected) return;

        const res = await axios.get(
          `${baseUrl}?apicall=getMultiQtRates&qmId=${Id}&quotNo=${selected.quotNo}`
        );
        console.log("data=>", res.data);

        setRates(res.data?.data || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchRates();
  }, [formData.quotId, quotList, Id, baseUrl]);
  const handleDropdownChange = (selectedOption) => {
    if (!selectedOption) return;

    // Update selected quotation in formData
    setFormData(prev => ({
      ...prev,
      quotId: selectedOption.ID
    }));

    // Show first table whenever user selects a quotation
    setShowRatesTable(true);

    // Fetch rates for the selected quotation
    const selected = quotList.find(q => q.ID === selectedOption.ID);
    if (!selected) return;

    axios.get(`${baseUrl}?apicall=getMultiQtRates&qmId=${Id}&quotNo=${selected.quotNo}`)
      .then(res => setRates(res.data?.data || []))
      .catch(err => console.error(err));
  };


  const dropdownQuotation = [
    {
      label: 'Quotation No',
      id: 'quotId',
      options: quotList?.filter(
        quot => !addedRows.some(item => item.quotNo === quot.quotNo)
      ) || [],
      value: formData.quotId, // store selected ID
      onChange: handleDropdownChange, // ✅ call the handler here


      getOptionLabel: (option) => option.quotNo || '',
      isOptionEqualToValue: (option, value) => option.ID === value?.ID,
      valueFinder: (options, value) => {
        if (Array.isArray(options)) {
          return options.find(item => item.ID === value) || null;
        }
        return null;
      },
    }
  ];



  const applyDiscount = () => {
    const milPct = parseFloat(milDiscount) || 0;
    const scrPct = parseFloat(scrDiscount) || 0;

  
        if (milPct <= 0) {
    alert("MIL % must be greater than 0");
    return;
  }

  if (scrPct > milPct) {
    alert("SCR % should be less than or equal to MIL %");
    return;
  }

    const updated = rates.map(row => {
      const mil = parseFloat(row.mil_rate) || 0;
      const retailer = parseFloat(row.retailer_rate) || 0;
      const mrp = parseFloat(row.mrp) || 0;
      const scr = parseFloat(row.scr_rate) || 0;

      // MIL Discount
      const newMIL = mil - (mil * milPct / 100);

      // Retailer Discount based on MIL %
      const newRetailer = retailer - (retailer * milPct / 100);

      // MRP Discount based on MIL %
      const newMrp = mrp - (mrp * milPct / 100);

      // SCR Discount
      const newSCR = scr - (scr * scrPct / 100);

      return {
        ...row,
        newMILRate: Math.round(newMIL),
        newRetailer: Math.round(newRetailer),
        newMrp: Math.round(newMrp),
        newSCRRate: Math.round(newSCR)
      };
    });

    setRates(updated);
  };
  const handleAdd = () => {
    const selected = quotList.find(q => q.ID === formData.quotId);
    if (!selected) return;

    const formatted = {
      quotNo: selected.quotNo,
      milPct: milDiscount,
      scrPct: scrDiscount,
      sizes: rates.map(r => r.size),
      mil: rates.map(r => r.mil_rate),
      disMil: rates.map(r => r.newMILRate || ""),
      retailerr: rates.map(r => r.retailer_rate),
      disRetailer: rates.map(r => r.newRetailer || ""),
      mrp: rates.map(r => r.mrp),
      disMrp: rates.map(r => r.newMrp || ""),
      scr: rates.map(r => r.scr_rate),
      disScr: rates.map(r => r.newSCRRate || "")
    };

    // Store added row
    setAddedRows(prev => [...prev, formatted]);

    // Clear MIL and SCR % and reset dropdown
    setMilDiscount("");
    setScrDiscount("");
    setFormData(prev => ({ ...prev, quotId: "" }));

    // Hide first table
    setShowRatesTable(false);

    // Show added table
    setShowAddedTable(true);
  };


  const selectedQuotation = quotList.find(q => q.ID === formData.quotId) || null;




  const handleSubmit = async () => {
    if (addedRows.length === 0) {
      alert("No data to save!");
      return;
    }

    try {
      const payload = {
        quotationId: Id, // main quotation ID
        discounts: addedRows, // second table data
      };

      const res = await axios.post(`${baseUrl}?apicall=insertMultiQuotationDiscounts`, payload);

      if (res.data?.msg === "Data Inserted") {
        alert("Data saved successfully!");
        setAddedRows([]);
        setShowAddedTable(false);
       // window.close();
      } else {
        alert(res.data?.msg || "Failed to save data");
       // window.close();
      }
    } catch (err) {
      console.error(err);
      alert("Error saving data. See console for details.");
    }
  };

  return (
    <Grid item xs={12}>
      <Paper style={{ padding: "3vh" }}>
        <div ref={componentRef}>
          <h3 className="centered-heading">Multiple Quotation Discount Entry</h3>
          <div className="dashed-line"></div>

          {/* Header */}
          <table style={{ margin: "1% 5%" }}>
            <tbody>
              <tr>
                <td>Firm Name</td>
                <td className="light-color">{formData.firmNm}</td>
                <td>Quot. No.</td>
                <td className="dark-color">{formData.qtMemo}</td>
              </tr>
              <tr>
                <td>Party Name</td>
                <td className="light-color">{formData.partyNm}</td>
              </tr>
            </tbody>
          </table>

          {/* ===== Single Line Controls ===== */}
          <Paper sx={{ p: 2, mx: "5%" }}>
            <Grid container spacing={2} alignItems="center">

              {/* Label */}
              <Grid item md={1.5}>
                <strong>Quotation No :</strong>
              </Grid>

              {/* Dropdown */}
              <Grid item md={2.5}>

                <DropdownWithBtn
                  options={quotList.filter(
                    quot => !addedRows.some(item => item.quotNo === quot.quotNo)
                  )}
                  value={quotList.find(q => q.ID === formData.quotId) || null} // ✅ selected value visible
                  onChange={handleDropdownChange}
                  getOptionLabel={option => option.quotNo || ''}
                  isOptionEqualToValue={(option, value) => option.ID === value?.ID}
                  valueFinder={(options, value) => options.find(item => item.ID === value) || null}
                  onButtonClick={handleAdd}
                  buttonText="Add"
                  placeholder="Select Quotation"
                />








              </Grid>

              {/* MIL */}
              <Grid item md={1.2}>
                <strong>Mil to Party % :</strong>
              </Grid>

              <Grid item md={1.5}>
                <TextField
                  size="small"
                  fullWidth
                  value={milDiscount}
                  onChange={(e) => setMilDiscount(e.target.value)}
                />
              </Grid>

              {/* SCR */}
              <Grid item md={1.2}>
                <strong>Scr to Mil % :</strong>
              </Grid>

              <Grid item md={1.5}>
                <TextField
                  size="small"
                  fullWidth
                  value={scrDiscount}
                  onChange={(e) => setScrDiscount(e.target.value)}
                />
              </Grid>

              {/* Apply */}
              <Grid item md={2} sx={{ display: 'flex', gap: '10px' }}>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={applyDiscount}
                  small
                >
                  Apply
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleAdd}
                  small
                >
                  Add
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => {
                    const filtered = addedRows.filter(row => !row.isSelected);
                    setAddedRows(filtered);
                  }}
                >
                  Delete
                </Button>


              </Grid>


              <Grid item md={2}>
              </Grid>



            </Grid>
          </Paper>
          
          {showRatesTable && rates.length > 0 && (
            
            <Table
              sx={{
                width: "70%",
                mx: "auto",
                mt: 3,
                borderCollapse: "collapse",
              }}
            >
              
              <TableHead>
                <TableRow>
<TableCell colSpan={9} sx={{ border: "1px solid #000", textAlign: "left", p: 0.5 }}>  <strong> Quotation No  :     {selectedQuotation?.quotNo}</strong>
</TableCell>

                </TableRow>
                <TableRow>
                  <TableCell padding="0.1" sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center", backgroundColor: "#e1b2b2" }}>Size</TableCell>
                  <TableCell padding="0.1" sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center", backgroundColor: "#e1b2b2" }}>SCR Rate</TableCell>
                  <TableCell padding="0.1" sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center", backgroundColor: "#e1b2b2" }}>Dis SCR</TableCell>

                  <TableCell padding="0.1" sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center", backgroundColor: "#e1b2b2" }}>Mil to Party Rate</TableCell>
                  <TableCell padding="0.1" sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center", backgroundColor: "#e1b2b2" }}>Dis MIL to Party Rate</TableCell>
                  <TableCell padding="0.1" sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center", backgroundColor: "#e1b2b2" }}>Retailer Rate</TableCell>
                  <TableCell padding="0.1" sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center", backgroundColor: "#e1b2b2" }}>Dis Retailer Rate</TableCell>
                  <TableCell padding="0.1" sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center", backgroundColor: "#e1b2b2" }}>MRP Rate</TableCell>
                  <TableCell padding="0.1" sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center", backgroundColor: "#e1b2b2" }}>Dis MRP Rate</TableCell>

                </TableRow>
              </TableHead>
              <TableBody>
                {rates.map((r, i) => (
                  <TableRow key={i}>
                    <TableCell padding="0.1" sx={{ border: "1px solid #000", textAlign: "center" }}>{r.size}</TableCell>

                    <TableCell padding="0.1" sx={{ border: "1px solid #000", textAlign: "center" }}>{r.scr_rate}</TableCell>
                    <TableCell padding="0.1" sx={{ border: "1px solid #000", textAlign: "center" }}>
                      <input
                        type="text"
                        value={r.newSCRRate || ""}
                        readOnly
                        style={{ width: "80px", color: "red", height: "30px", textAlign: "center" }}
                      />
                    </TableCell>
                    <TableCell padding="0.1" sx={{ border: "1px solid #000", textAlign: "center" }}>{r.mil_rate}</TableCell>
                    <TableCell padding="0.1" sx={{ border: "1px solid #000", textAlign: "center" }}>
                      <input
                        type="text"
                        value={r.newMILRate || ""}
                        readOnly
                        style={{ width: "80px", color: "red", height: "30px", textAlign: "center" }}
                      />
                    </TableCell>
                    <TableCell padding="0.1" sx={{ border: "1px solid #000", textAlign: "center" }}>{r.retailer_rate}</TableCell>
                    <TableCell padding="0.1" sx={{ border: "1px solid #000", textAlign: "center" }}>
                      <input
                        type="text"
                        value={r.newRetailer || ""}
                        readOnly
                        style={{ width: "80px", color: "red", height: "30px", textAlign: "center" }}
                      />
                    </TableCell>
                    <TableCell padding="0.1" sx={{ border: "1px solid #000", textAlign: "center" }}>{r.mrp}</TableCell>
                    <TableCell padding="0.1" sx={{ border: "1px solid #000", textAlign: "center" }}>
                      <input
                        type="text"
                        value={r.newMrp || ""}
                        readOnly
                        style={{ width: "80px", color: "red", height: "30px", textAlign: "center" }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}


          {addedRows.length > 0 && (
            <Grid container sx={{ width: '90%', mx: 'auto', mt: 3 }}>
              <Grid item xs={12}>
                <strong style={{ display: 'block', marginBottom: '8px', fontSize: '16px' }}>
                  QT Discount Rate Details
                </strong>
                <TableContainer
                  sx={{
                    maxHeight: 400,
                    width: '100%',
                    border: '1px solid #fff',
                  }}
                >
                  <Table stickyHeader sx={{ borderCollapse: 'collapse' }}>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center", backgroundColor: "#e1b2b2" }}
                        >
                          Select
                        </TableCell>
                        <TableCell sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center", backgroundColor: "#e1b2b2" }}>
                          Quotation No
                        </TableCell>
                        <TableCell sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center", backgroundColor: "#e1b2b2" }}>
                          Size
                        </TableCell>
                        <TableCell sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center", backgroundColor: "#e1b2b2" }}>
                          MIL Rate
                        </TableCell>
                        <TableCell sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center", backgroundColor: "#e1b2b2" }}>
                          Dis MIL %
                        </TableCell>
                        <TableCell sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center", backgroundColor: "#e1b2b2" }}>
                          Dis MIL Rate
                        </TableCell>
                        <TableCell sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center", backgroundColor: "#e1b2b2" }}>
                          Retailer Rate
                        </TableCell>

                        <TableCell sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center", backgroundColor: "#e1b2b2" }}>
                          Dis Retailer Rate
                        </TableCell>

                        <TableCell sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center", backgroundColor: "#e1b2b2" }}>
                          MRP Rate
                        </TableCell>

                        <TableCell sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center", backgroundColor: "#e1b2b2" }}>
                          Dis MRP Rate
                        </TableCell>
                        <TableCell sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center", backgroundColor: "#e1b2b2" }}>
                          SCR Rate
                        </TableCell>
                        <TableCell sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center", backgroundColor: "#e1b2b2" }}>
                          Dis SCR %
                        </TableCell>
                        <TableCell sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center", backgroundColor: "#e1b2b2" }}>
                          Dis SCR Rate
                        </TableCell>
                        {/* <TableCell sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center",backgroundColor: "#e1b2b2" }}>
                View
              </TableCell> */}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {addedRows.map((row, idx) => (
                        <TableRow key={idx}>
                          <TableCell sx={{ border: "1px solid #000", textAlign: "center" }}>
                            <input
                              type="checkbox"
                              checked={row.isSelected || false}
                              onChange={(e) => {
                                const updated = [...addedRows];
                                updated[idx].isSelected = e.target.checked;
                                setAddedRows(updated);
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ border: "1px solid #000", textAlign: "center" }}>
                            {row.quotNo}
                          </TableCell>
                          <TableCell sx={{ border: "1px solid #000", textAlign: "center" }}>
                            {row.sizes.join(",")}
                          </TableCell>
                          <TableCell sx={{ border: "1px solid #000", textAlign: "center" }}>
                            {row.mil.join(",")}
                          </TableCell>
                          <TableCell sx={{ border: "1px solid #000", textAlign: "center" }}>
                            {row.milPct}%
                          </TableCell>
                          <TableCell sx={{ border: "1px solid #000", textAlign: "center" }}>
                            {row.disMil.join(",")}
                          </TableCell>
                          <TableCell sx={{ border: "1px solid #000", textAlign: "center" }}>
                            {row.retailerr.join(",")}
                          </TableCell>

                          <TableCell sx={{ border: "1px solid #000", textAlign: "center" }}>
                            {row.disRetailer.join(",")}
                          </TableCell>

                          <TableCell sx={{ border: "1px solid #000", textAlign: "center" }}>
                            {row.mrp.join(",")}
                          </TableCell>

                          <TableCell sx={{ border: "1px solid #000", textAlign: "center" }}>
                            {row.disMrp.join(",")}
                          </TableCell>
                          <TableCell sx={{ border: "1px solid #000", textAlign: "center" }}>
                            {row.scr.join(",")}
                          </TableCell>
                          <TableCell sx={{ border: "1px solid #000", textAlign: "center" }}>
                            {row.scrPct}%
                          </TableCell>
                          <TableCell sx={{ border: "1px solid #000", textAlign: "center" }}>
                            {row.disScr.join(",")}
                          </TableCell>
                          {/* <TableCell sx={{ border: "1px solid #000", textAlign: "center" }}>
                  <Button variant="outlined" size="small">View</Button>
                </TableCell> */}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          )}




        </div>

        {/* Footer */}
        <div style={{ margin: "2% 5%", display: "flex", gap: "10px" }}>
          <Button variant="contained" onClick={handleSubmit}>
            Submit
          </Button>

          <ReactToPrint
            trigger={() => <Button variant="contained">Print</Button>}
            content={() => componentRef.current}
          />
                         
          {/* 👇 Add here */}


        </div>
          <QuotDiscountTable Id={Id}/>

      </Paper>
    </Grid>
  );
};


export default QuotDiscount;
